(function () {
  const root = document.querySelector("[data-b2b-page]");
  if (!root) return;

  const b2bNav = root.querySelector(".b2b-nav");
  let scrollTicking = false;
  function updateScrollProgress() {
    const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const progress = Math.min(100, Math.max(0, (window.scrollY / max) * 100));
    b2bNav?.style.setProperty("--b2b-scroll-progress", `${progress}%`);
    scrollTicking = false;
  }
  window.addEventListener("scroll", () => {
    if (!scrollTicking) {
      scrollTicking = true;
      requestAnimationFrame(updateScrollProgress);
    }
  }, { passive: true });
  updateScrollProgress();

  const navLinks = [...root.querySelectorAll('.b2b-nav__links a[href^="#"]')];
  const navTargets = navLinks
    .map((link) => ({ link, target: root.querySelector(link.getAttribute("href")) }))
    .filter((item) => item.target);
  if ("IntersectionObserver" in window) {
    const navObserver = new IntersectionObserver((entries) => {
      const visible = entries.find((entry) => entry.isIntersecting);
      if (!visible) return;
      navTargets.forEach(({ link, target }) => link.classList.toggle("is-active", target === visible.target));
    }, { rootMargin: "-28% 0px -62% 0px", threshold: 0 });
    navTargets.forEach(({ target }) => navObserver.observe(target));
  }

  const prices = {
    1.75: { name: "1,75 kg Set", weight: 1.75, shipping: 4.37, parcel: "S", tiers: [25.13, 23.87, 22.62, 21.36, 20.1] },
    3: { name: "3 kg Set", weight: 3, shipping: 4.37, parcel: "S", tiers: [36.89, 35.05, 33.2, 31.36, 29.51] },
    6: { name: "6 kg Set", weight: 6, shipping: 4.37, parcel: "S", tiers: [66.39, 63.07, 59.75, 56.43, 53.11] },
    10: { name: "10 kg Set", weight: 10, shipping: 5.94, parcel: "M", tiers: [100, 95, 90, 85, 80] },
    20: { name: "20 kg Set", weight: 20, shipping: 5.94, parcel: "M", tiers: [184.03, 174.83, 165.63, 156.43, 147.22] },
  };
  const tiers = [
    { min: 40, rate: 0.2, label: "20 %" },
    { min: 30, rate: 0.15, label: "15 %" },
    { min: 15, rate: 0.1, label: "10 %" },
    { min: 5, rate: 0.05, label: "5 %" },
    { min: 1, rate: 0, label: "0 %" },
  ];
  const euro = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });
  const fire = (name, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...detail });
        // Reuse the Google tag already loaded by GTM. This sends B2B events
    // to GA4 without adding another global script or touching B2C templates.
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    if (!window.__harz4uB2bGa4Configured) {
            window.gtag("config", "G-XEQZR1NFQ9", { send_page_view: false });
                  window.__harz4uB2bGa4Configured = true;
                      }
                          window.gtag("event", name, { ...detail, send_to: "G-XEQZR1NFQ9" });
root.dispatchEvent(new CustomEvent(name, { detail, bubbles: true }));
  };
  fire("b2b_view", {
    segment: new URLSearchParams(location.search).get("segment") || "unknown",
  });

  const params = new URLSearchParams(location.search);
  const tracked = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "segment",
  ];
  root.querySelectorAll("form").forEach((form) =>
    tracked.forEach((key) => {
      let field = form.querySelector(`[name="${key}"]`);
      if (!field) {
        field = document.createElement("input");
        field.type = "hidden";
        field.name = key;
        form.appendChild(field);
      }
      field.value = params.get(key) || "";
    }),
  );
  root.querySelectorAll("[data-b2b-param]").forEach((field) => {
    field.value = params.get(field.dataset.b2bParam) || "";
  });
  root.querySelectorAll("[data-preserve-query]").forEach((link) => {
    try {
      const url = new URL(link.href, location.origin);
      tracked.forEach((k) => {
        if (params.has(k)) url.searchParams.set(k, params.get(k));
      });
      link.href = url.toString();
    } catch (e) {}
  });

  const segment = params.get("segment");
  const segmentMessages = {
    bodenbeschichtung: {
      headline: "Epoxidharz für Beschichtung und Sanierung.",
      copy: "Passende Sets von 1,75 bis 20 kg, feste Nettopreise und bis zu 20 % Mengenrabatt – für planbare Boden-, Flächen- und Bautenschutzaufträge.",
    },
    maler: {
      headline: "Epoxidharz für Reparatur und Beschichtung.",
      copy: "Passende Gebinde für Sanierung, Reparatur und wiederkehrende Beschichtungsarbeiten – mit transparenten Nettopreisen und festen Mengenstaffeln.",
    },
    gfk: {
      headline: "Epoxidharz für Laminat, Form und Reparatur.",
      copy: "Sets von 1,75 bis 20 kg für GFK-, Boots-, Formen- und Modellbau – mit planbaren Nettopreisen und bis zu 20 % Mengenrabatt.",
    },
    holz: {
      headline: "Epoxidharz für Möbel, Verguss und Kleinserie.",
      copy: "Passende Gebinde für Tischplatten, Möbelstücke, Vergüsse und wiederkehrende Resin-Arbeiten – transparent kalkuliert für Ihren Betrieb.",
    },
    sonderbau: {
      headline: "Epoxidharz für Projekte, die nicht von der Stange sind.",
      copy: "Gebinde, Mengen und Lieferung passend zu Ihrem Vorhaben – mit direkter Beratung und einem individuellen Angebot für besondere Anforderungen.",
    },
    handel: {
      headline: "Epoxidharz-Konditionen für Fachhandel und Wiederverkauf.",
      copy: "Feste Nettopreise, klare Mengenstaffeln und persönliche Abstimmung für regelmäßige Bestellungen und größere Abnahmemengen.",
    },
  };
  if (segment) {
    const segmentRow = root.querySelector(
      `[data-segment="${CSS.escape(segment)}"]`,
    );
    if (segmentRow) segmentRow.classList.add("is-active");
    root.querySelectorAll('select[name="industry"],select[data-industry]').forEach((select) => {
      if ([...select.options].some((o) => o.value === segment))
        select.value = segment;
    });
    const message = segmentMessages[segment];
    if (message) {
      const headline = root.querySelector("[data-segment-headline]");
      const copy = root.querySelector("[data-segment-copy]");
      if (headline) headline.textContent = message.headline;
      if (copy) copy.textContent = message.copy;
    }
  }

  const product = root.querySelector("[data-calc-product]");
  const qtyRange = root.querySelector("[data-calc-range]");
  const qtyInput = root.querySelector("[data-calc-qty]");
  const unitEl = root.querySelector("[data-calc-unit]");
  const totalEl = root.querySelector("[data-calc-total]");
  const savingEl = root.querySelector("[data-calc-saving]");
  const freightEl = root.querySelector("[data-calc-freight]");
  const parcelEl = root.querySelector("[data-calc-parcels]");
  const weightEl = root.querySelector("[data-calc-weight]");
  const shippingBaseEl = root.querySelector("[data-calc-shipping-base]");
  const shippingDiscountEl = root.querySelector("[data-calc-shipping-discount]");
  const peakEl = root.querySelector("[data-calc-peak]");
  const shippingFinalEl = root.querySelector("[data-calc-shipping-final]");
  const shippingStatusEl = root.querySelector("[data-calc-shipping-status]");
  let calcTimer;
  function updateCalc(source) {
    if (!product || !qtyInput) return;
    const item = prices[product.value];
    const qty = Math.max(1, Math.min(80, parseInt(qtyInput.value || 1, 10)));
    qtyInput.value = qty;
    if (qtyRange) qtyRange.value = qty;
    const tier = tiers.find((t) => qty >= t.min);
    const tierIndex = tiers.length - 1 - tiers.indexOf(tier);
    const unit = item.tiers[tierIndex];
    const total = Math.round(unit * qty * 100) / 100;
    const saving = Math.round((item.tiers[0] * qty - total) * 100) / 100;
    unitEl.textContent = euro.format(unit);
    totalEl.textContent = euro.format(total);
    savingEl.textContent = euro.format(saving);
    [unitEl, totalEl, savingEl].forEach((el) => {
      el.classList.remove("is-updating");
      void el.offsetWidth;
      el.classList.add("is-updating");
    });
    const kg = item.weight * qty;
    const shippingDiscount = kg >= 300 && kg <= 400 ? 0.4 : kg >= 200 ? 0.3 : kg >= 100 ? 0.25 : 0;
    const shippingBase = Math.round(item.shipping * qty * 100) / 100;
    const shippingSaving = Math.round(shippingBase * shippingDiscount * 100) / 100;
    const today = new Date();
    const peakActive = today.getMonth() >= 9;
    const peakNet = kg > 400 || !peakActive ? 0 : Math.round(qty * 0.25 * 100) / 100;
    const shippingNet = kg > 400 ? 0 : Math.round((shippingBase - shippingSaving + peakNet) * 100) / 100;
    parcelEl.textContent = `${qty} × Hermes ${item.parcel}`;
    weightEl.textContent = `${kg.toLocaleString("de-DE")} kg`;
    shippingBaseEl.textContent = euro.format(shippingBase);
    shippingDiscountEl.textContent = shippingDiscount ? `−${euro.format(shippingSaving)} (${Math.round(shippingDiscount * 100)} %)` : "0,00 €";
    peakEl.textContent = peakActive && kg <= 400 ? `+${euro.format(peakNet)}` : "entfällt";
    shippingFinalEl.textContent = kg > 400 ? "auf Anfrage" : euro.format(shippingNet);
    shippingStatusEl.textContent = kg > 400
      ? "Über 400 kg prüft Harz4u Palette oder Spedition und sendet ein verbindliches Frachtangebot."
      : `${euro.format(shippingNet)} netto zzgl. 19 % Umsatzsteuer${peakActive ? " · inklusive Hermes-Peak-Zuschlag von 0,25 € je Paket" : ""}.`;
    freightEl.classList.toggle("is-freight", kg > 400);
    root
      .querySelectorAll("[data-tier-min]")
      .forEach((row) =>
        row.classList.toggle(
          "is-current",
          Number(row.dataset.tierMin) === tier.min,
        ),
      );
    clearTimeout(calcTimer);
    calcTimer = setTimeout(
      () => {
        const detail = {
          product: item.name,
          quantity: qty,
          discount: tier.rate,
          total_net: total,
          weight_kg: kg,
          shipping_net: shippingNet,
          shipping_discount: shippingDiscount,
          source,
        };
        fire("pricing_calculated", detail);
        fire("shipping_calculated", {
          ...detail,
          parcel_class: item.parcel,
          parcel_count: qty,
          freight_review: kg > 400,
          peak_surcharge_net: peakNet,
        });
      },
      280,
    );
  }
  if (product && qtyRange && qtyInput) {
    product.addEventListener("change", () => updateCalc("product"));
    qtyRange.addEventListener("input", () => {
      qtyInput.value = qtyRange.value;
      updateCalc("range");
    });
    qtyInput.addEventListener("input", () => {
      qtyRange.value = qtyInput.value;
      updateCalc("input");
    });
    updateCalc("initial");
  }

  const revealObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) =>
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible");
                revealObserver.unobserve(entry.target);
              }
            }),
          { threshold: 0.14 },
        )
      : null;
  root
    .querySelectorAll(".b2b-reveal,.b2b-step")
    .forEach((el) =>
      revealObserver
        ? revealObserver.observe(el)
        : el.classList.add("is-visible"),
    );

  root
    .querySelectorAll("[data-track]")
    .forEach((el) =>
      el.addEventListener("click", () =>
        fire(el.dataset.track, {
          target: el.getAttribute("href") || el.dataset.track,
        }),
      ),
    );

  function trackQuoteInKlaviyo(form) {
    const data = new FormData(form);
    const value = (name) => String(data.get(name) || "").trim();
    const email = value("contact[email]");
    if (!email) return Promise.resolve();
    const fullName = value("contact[name]");
    const nameParts = fullName.split(/\s+/).filter(Boolean);
    const firstName = nameParts.shift() || fullName;
    const lastName = nameParts.join(" ");
    const company = value("contact[Unternehmen]");
    const phone = value("contact[phone]").replace(/[^\d+]/g, "");
    const properties = {
      company,
      contact_name: fullName,
      phone,
      industry: value("contact[Gewerbe]"),
      requested_quantity: value("contact[Gewünschte Menge]"),
      project_date: value("contact[Projekttermin]"),
      delivery_postcode: value("contact[Liefer-PLZ]"),
      message: value("contact[body]"),
      preferred_channel: value("contact[Bevorzugter Rückkanal]"),
      utm_source: value("contact[UTM Source]"),
      utm_medium: value("contact[UTM Medium]"),
      utm_campaign: value("contact[UTM Campaign]"),
      utm_content: value("contact[UTM Content]"),
      utm_term: value("contact[UTM Term]"),
      segment: value("contact[Segment]"),
    };
    const profileAttributes = {
      email,
      first_name: firstName,
      last_name: lastName,
      organization: company,
      locale: "de-DE",
      properties: {
        B2B_QUOTE: true,
        B2B_SOURCE: "Harz4u B2B",
      },
    };
    if (/^\+[1-9]\d{6,14}$/.test(phone)) profileAttributes.phone_number = phone;
    const payload = {
      data: {
        type: "event",
        attributes: {
          unique_id: `b2b-quote-${Date.now()}-${Math.random().toString(36).slice(2)}`,
          properties,
          metric: {
            data: {
              type: "metric",
              attributes: { name: "B2B Quote Submitted" },
            },
          },
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes,
            },
          },
        },
      },
    };
    return fetch("https://a.klaviyo.com/client/events/?company_id=Svs9aC", {
      method: "POST",
      headers: {
        "content-type": "application/vnd.api+json",
        revision: "2026-07-15",
      },
      body: JSON.stringify(payload),
      keepalive: true,
    }).then((response) => {
      if (!response.ok) throw new Error(`Klaviyo event rejected (${response.status})`);
    });
  }

  root.querySelectorAll("form").forEach((form) => {
    const type = form.dataset.formType;
    const started =
      type === "quote" ? "quote_started" : "company_registration_started";
    const submitted =
      type === "quote" ? "quote_submitted" : "company_registration_completed";
    let touched = false;
    form.addEventListener(
      "focusin",
      () => {
        if (!touched) {
          touched = true;
          fire(started);
        }
      },
      { once: true },
    );
    form.addEventListener("submit", (event) => {
      if (form.dataset.preview === "true") {
        event.preventDefault();
        const status = form.querySelector("[data-form-status]");
        if (status)
          status.textContent =
            "Vorschau: Formular vollständig geprüft. Die produktive Übermittlung wird erst nach Freigabe aktiviert.";
      } else if (type === "quote" && form.dataset.klaviyoTracked !== "true") {
        event.preventDefault();
        form.dataset.klaviyoTracked = "true";
        Promise.race([
          trackQuoteInKlaviyo(form),
          new Promise((resolve) => setTimeout(resolve, 1500)),
        ]).finally(() => HTMLFormElement.prototype.submit.call(form));
      }
      fire(submitted, {
        industry:
          form.elements.industry?.value ||
          form.querySelector("[data-industry]")?.value ||
          "",
        utm_campaign:
          form.elements.utm_campaign?.value ||
          form.querySelector('[data-b2b-param="utm_campaign"]')?.value ||
          "",
      });
    });
  });

  const companySegmentLabels = {
    bodenbeschichtung: "Boden- und Bautenschutz",
    maler: "Maler / Lackierer / Sanierung",
    gfk: "GFK / Boot / Formenbau",
    holz: "Tischlerei / Möbel / Resin",
    sonderbau: "Teich / Terrarium / Sonderbau",
    handel: "Wiederverkäufer / Fachhandel",
  };
  function trackCompanyRegistrationInKlaviyo(form, shadow) {
    const value = (id) => String(shadow.getElementById(id)?.value || "").trim();
    const email = value("email");
    if (!email) return Promise.resolve();
    const firstName = value("first_name");
    const lastName = value("last_name");
    const phone = value("phone_number").replace(/[^\d+]/g, "");
    const company = value("company_name");
    const properties = {
      company,
      contact_name: [firstName, lastName].filter(Boolean).join(" "),
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      billing_first_name: value("billing_address_first_name"),
      billing_last_name: value("billing_address_last_name"),
      billing_recipient: value("billing_address_recipient"),
      billing_address_1: value("billing_address_address1"),
      billing_address_2: value("billing_address_address2"),
      billing_postcode: value("billing_address_zip"),
      billing_city: value("billing_address_city"),
      billing_phone: value("billing_address_phone").replace(/[^\d+]/g, ""),
      vat_id: value("company_tax_id"),
      website: value("custom#website_optional"),
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      utm_term: params.get("utm_term") || "",
      segment: segment || "",
    };
    const profileAttributes = {
      email,
      first_name: firstName,
      last_name: lastName,
      organization: company,
      locale: "de-DE",
      properties: {
        B2B_REGISTRATION: true,
        B2B_SOURCE: "Harz4u B2B",
      },
    };
    if (/^\+[1-9]\d{6,14}$/.test(phone)) profileAttributes.phone_number = phone;
    return fetch("https://a.klaviyo.com/client/events/?company_id=Svs9aC", {
      method: "POST",
      headers: {
        "content-type": "application/vnd.api+json",
        revision: "2026-07-15",
      },
      body: JSON.stringify({
        data: {
          type: "event",
          attributes: {
            unique_id: `b2b-registration-${Date.now()}-${Math.random().toString(36).slice(2)}`,
            properties,
            metric: { data: { type: "metric", attributes: { name: "B2B Company Registration Submitted" } } },
            profile: { data: { type: "profile", attributes: profileAttributes } },
          },
        },
      }),
      keepalive: true,
    }).then((response) => {
      if (!response.ok) throw new Error(`Klaviyo registration event rejected (${response.status})`);
    });
  }
  let companyFormAttempts = 0;
  function enhanceCompanyForm() {
    companyFormAttempts += 1;
    const host = root.querySelector("shopify-forms-embed");
    const shadow = host?.shadowRoot;
    const companyForm = shadow?.querySelector("form");
    if (!host || !shadow || !companyForm) {
      if (companyFormAttempts < 20) setTimeout(enhanceCompanyForm, 250);
      return;
    }

    shadow
      .querySelectorAll('input[type="checkbox"][name="custom#bestaetigungen"]')
      .forEach((checkbox) => {
        checkbox.required = true;
        checkbox.setAttribute("aria-required", "true");
      });

    if (companyForm.dataset.b2bTrackingBound !== "true") {
      companyForm.dataset.b2bTrackingBound = "true";
      companyForm.addEventListener(
        "focusin",
        () => fire("company_registration_started"),
        { once: true },
      );
      companyForm.addEventListener("submit", () => {
        trackCompanyRegistrationInKlaviyo(companyForm, shadow).catch((error) =>
          console.error("B2B registration tracking failed", error),
        );
        fire("company_registration_completed", {
          segment: segment || "",
          utm_campaign: params.get("utm_campaign") || "",
        });
      });
    }

    const segmentLabel = companySegmentLabels[segment];
    if (segmentLabel && host.dataset.b2bSegmentSelected !== segment) {
      const selector = shadow.querySelector(
        'button[aria-labelledby*="custom#gewerbe_zielgruppe-selector-label"]',
      );
      if (selector) {
        selector.click();
        setTimeout(() => {
          const option = [...shadow.querySelectorAll('[role="option"]')].find(
            (item) => item.textContent.trim() === segmentLabel,
          );
          if (option) {
            option.click();
            host.dataset.b2bSegmentSelected = segment;
          }
        }, 40);
      }
    }

    if (companyFormAttempts < 8) setTimeout(enhanceCompanyForm, 300);
  }
  enhanceCompanyForm();

  const calHolder = root.querySelector("[data-cal-holder]");
  const calUrl = root.dataset.calUrl;
  if (calHolder && calUrl && /^https:\/\/cal\.com\//i.test(calUrl)) {
    const iframe = document.createElement("iframe");
    iframe.src = calUrl;
    iframe.title = "Beratungstermin buchen";
    iframe.loading = "lazy";
    calHolder.innerHTML = "";
    calHolder.appendChild(iframe);
  }
})();
